import { environment } from '../../../environments/environment';
import { SERVICES } from '@root/constant';
export class Urls {
  public static baseApiUrl = `${SERVICES.CATALOG.PATH}/adminportal/`;

  // Banner
  public static uploadBanner = Urls.baseApiUrl + 'uploadBanner';
  public static getSchemes = Urls.baseApiUrl + 'getSchemes';
  public static getBanners = Urls.baseApiUrl + 'getBanners';
  public static deleteBanners = Urls.baseApiUrl + 'deleteBanners';

  // Key Feature
  public static uploadKeyFeature = Urls.baseApiUrl + 'uploadKeyFeatureImage';
  public static getKeyHeadings = Urls.baseApiUrl + 'getKeyHeadings';

  // Fund Manager
  public static uploadFundManager = Urls.baseApiUrl + 'uploadFundMangerImage';
  public static getFundManagers = Urls.baseApiUrl + 'getFundManagers';

  // Excel
  public static uploadProductDetails = Urls.baseApiUrl + 'uploadProductDetails';
  public static uploadProductReturns = Urls.baseApiUrl + 'uploadProductReturns';
  public static uploadAssetallocation =
    Urls.baseApiUrl + 'uploadAssetallocation';
  public static uploadSector = Urls.baseApiUrl + 'uploadSector';
  public static uploadStocks = Urls.baseApiUrl + 'uploadStocks';
  public static uploadLocateAdvisor = Urls.baseApiUrl + 'uploadLocateAdvisor';
  public static uploadAMC = Urls.baseApiUrl + 'uploadAMC';
  public static uploadKeyfeatures = Urls.baseApiUrl + 'uploadKeyfeatures';
  public static uploadState = Urls.baseApiUrl + 'uploadState';
  public static uploadCity = Urls.baseApiUrl + 'uploadCity';
  public static uploadPointOfAcceptance =
    Urls.baseApiUrl + 'uploadPointOfAcceptance';
  public static uploadKfin = Urls.baseApiUrl + 'uploadKfin';
  // User data
  public static getinfo = Urls.baseApiUrl + 'getinfo';
  public static deleteinfo = Urls.baseApiUrl + 'deleteinfo';

  public static getCustomerContactDetails =
    Urls.baseApiUrl + 'getCustomerContactDetails';
  public static deleteCustomerContact =
    Urls.baseApiUrl + 'deleteCustomerContact';

  // Videos
  public static getProductVideo = Urls.baseApiUrl + 'getVideos';
  public static uploadProductVideo = Urls.baseApiUrl + 'uploadVideo';
  public static editProductVideo = Urls.baseApiUrl + 'editVideo';
  public static deleteProductVideo = Urls.baseApiUrl + 'deleteVideo';

  public static uploadInvestorVideo = Urls.baseApiUrl + 'uploadInvestorVideo';
  public static getInvestorVideos = Urls.baseApiUrl + 'getInvestorVideos';
  public static editInvestorVideo = Urls.baseApiUrl + 'editInvestorVideo';
  public static deleteInvestorVideo = Urls.baseApiUrl + 'deleteInvestorVideo';

  // Set sections
  public static getTypes = Urls.baseApiUrl + 'getTypes';

  public static getSections = Urls.baseApiUrl + 'getSections';
  public static addSection = Urls.baseApiUrl + 'addSections';
  public static editSection = Urls.baseApiUrl + 'editSections';
  public static deleteSection = Urls.baseApiUrl + 'deleteSections';

  public static getSubSections = Urls.baseApiUrl + 'getSubSections';
  public static addSubSection = Urls.baseApiUrl + 'addSubSections';
  public static editSubSection = Urls.baseApiUrl + 'editSubSections';
  public static deleteSubSection = Urls.baseApiUrl + 'deleteSubSections';

  public static getSectionsByType = Urls.baseApiUrl + 'getSectionsByType';

  // Upload Section docs
  public static uploadSectionDocuments = Urls.baseApiUrl + 'uploadMFDocuments';
  public static deleteSectionDocuments = Urls.baseApiUrl + 'deleteMFDocuments';
  public static getSectionDocs = Urls.baseApiUrl + 'getmfdocs';

  // Upload Sub Section docs
  public static uploadSubSectionDocuments =
    Urls.baseApiUrl + 'uploadPartnerDocuments';
  public static deleteSubSectionDocuments =
    Urls.baseApiUrl + 'deletePartnerDocuments';
  public static getSubSectiondocs = Urls.baseApiUrl + 'getpartnerdocs';

  public static getSubSectionsByType = Urls.baseApiUrl + 'getSubSectionsByType';
}
